import {Placement} from '@popperjs/core';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {Layer} from '../../../../libs/shared/ui/src/components/layers/layer';
import {Anchor} from '../../../../libs/shared/ui/src/components/reposition/repositionHelpers';
import {RepositionOverlay} from '../../../../libs/shared/ui/src/components/reposition/repositionOverlay';

/*
 * Props.
 */

interface InfoBubbleArrowProps {
  /** Ref to the anchor, or bounds provider. */
  anchor: Anchor;
  /** The placement orientation of the info bubble relative to its target. */
  position: Placement;
  /** If the overlay is interactive, pointer events will not pass through. */
  isInteractive?: boolean;
}

/*
 * Style.
 */

function getArrowStyleForPosition(position: Placement) {
  switch (position) {
    case 'right': {
      return css`
        border-top: 10px solid transparent;
        border-right: 8px solid ${(p) => p.theme.greys.white};
        border-bottom: 10px solid transparent;
        position: absolute;
        right: -32px;
        top: calc(50% - 10px);
      `;
    }
    case 'left': {
      return css`
        border-top: 10px solid transparent;
        border-left: 8px solid ${(p) => p.theme.greys.white};
        border-bottom: 10px solid transparent;
        position: absolute;
        left: -30px;
        top: calc(50% - 10px);
      `;
    }
    case 'top': {
      return css`
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 8px solid ${(p) => p.theme.greys.white};
        position: absolute;
        top: -30px;
        left: calc(50% - 10px);
      `;
    }
    case 'bottom': {
      return css`
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 8px solid ${(p) => p.theme.greys.white};
        position: absolute;
        bottom: -30px;
        left: calc(50% - 10px);
      `;
    }
    default: {
      return '';
    }
  }
}

interface ArrowStyleProps {
  $position: Placement;
}
const StyledArrowDiv = styled.div<ArrowStyleProps>`
  width: 0;
  height: 0;
  pointer-events: inherit;
  ${(p) => getArrowStyleForPosition(p.$position)}
`;

/*
 * Component.
 */

export const InfoBubbleArrow: FC<InfoBubbleArrowProps> = ({anchor, position, isInteractive}) => (
  <Layer>
    <RepositionOverlay anchor={anchor} isInteractive={isInteractive}>
      <StyledArrowDiv $position={position} />
    </RepositionOverlay>
  </Layer>
);
